<div class="new-notification" *ngIf="notification.show && notification.company">
  <p>
    {{ 'new_strategy.notifications.success' | translate }} {{ notification.company }}
    {{ actionTranslationKey | translate }}
  </p>
  <p>
    <a class="pull-right" (click)="undoChanges()">{{ 'new_strategy.notifications.undo' | translate }}</a>
  </p>
</div>
